import type { CONTENT_TYPE } from "../components/content/Type";

export const MEDIA_FORMATS = {
  SERIE: "serie",
  ONE_OFF: "one_off",
  FEATURE_FILM: "feature_film",
  COLLECTION: "collection",
  ADPOD: "adpod",
  LIVE: "live",
  SHORT_PROGRAM: "short_program",
  PODCAST: "podcast",
  CHIP: "chip",
  MINI_SERIES: "mini-series",
  PROMOTION: "promotion",
  SHORT_FILM: "short_film",
  BUMPER: "bumper",
} as const;

export const AD_BREAK = "ad_break";

export const TIMESLOT = "timeslot";

export type MediaFormatKeys = keyof typeof MEDIA_FORMATS;

export type MediaFormat = (typeof MEDIA_FORMATS)[MediaFormatKeys];

export const MEDIA_STATUS = {
  ARCHIVED: "archived",
  ENABLED: "enabled",
  DISABLED: "disabled",
} as const;

export type MediaStatusKeys = keyof typeof MEDIA_STATUS;

export type MediaStatus = (typeof MEDIA_STATUS)[MediaStatusKeys];

export type MediaTypeKeys = keyof typeof CONTENT_TYPE;

export type MediaType = (typeof CONTENT_TYPE)[MediaTypeKeys];

export const MEDIA_PUBLICATION_STATUS = {
  ACTIVE: "active",
  PAUSE: "pause",
  STOP: "stop",
} as const;

export type MediaPublicationStatusKeys = keyof typeof MEDIA_PUBLICATION_STATUS;

export type MediaPublicationStatus =
  (typeof MEDIA_PUBLICATION_STATUS)[MediaPublicationStatusKeys];

export const MEDIA_PUBLICATION_REASONS = {
  AFTER_END_DATE: "after_end_date",
  NO_STREAMS: "no_streams",
};

export type MediaPublicationReasonKeys = keyof typeof MEDIA_PUBLICATION_REASONS;

export type MediaPublicationReason =
  (typeof MEDIA_PUBLICATION_REASONS)[MediaPublicationReasonKeys];

export type MediaFormatWithAdBreak = MediaFormat | typeof AD_BREAK;

export const MEDIA_FORMATS_AD_BREAKS: MediaFormat[] = [
  MEDIA_FORMATS.BUMPER,
  MEDIA_FORMATS.PROMOTION,
  MEDIA_FORMATS.ADPOD,
];

export type AdBreakFormat =
  | typeof MEDIA_FORMATS.ADPOD
  | typeof MEDIA_FORMATS.BUMPER
  | typeof MEDIA_FORMATS.PROMOTION;

export const VTT_FILE_TYPES = {
  CHAPTERS: "chapters",
  SUBTITLES: "subtitles",
} as const;

type VttFileTypeKeys = keyof typeof VTT_FILE_TYPES;

export type VttFileType = (typeof VTT_FILE_TYPES)[VttFileTypeKeys];

export const CUEPOINT_TIMECODE_REGEX =
  /^\d{2}:([0-5][0-9]):([0-5][0-9]):([0-2][0-9])$/;

export const DEFAULT_FRAME_RATE = 30;

export const DURATION_FILTER_LIST = [0, 5, 15, 30, 45, 60, 90, 120, 180];
